//Promocode Updated
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Typography,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../lib/axios";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from "../../../../GlobalFunction/CrudButtons";

const PromoCodeMaster = () => {
  const { register, setValue, watch, reset } = useForm();
  const [PromoData, setPromoData] = useState([]);
  const [Mode, setMode] = useState("add");
  const [AllButtonDisabled, setAllButtonDisabled] = useState(false);
  const [AllTextDisabled, setAllTextDisabled] = useState(false);
  const [openConfirmDialog, setopenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const [PromoId, setPromoId] = useState(-1);
  const location = useLocation();
  const navigate = useNavigate();
  const [DiscType, setDiscType] = useState("M");
  const [UserId] = useState(sessionStorage.getItem("UserId"));

  // console.log("disc", DiscType);

  useEffect(() => {
    const fetchCompanyData = async () => {
      if (location.state) {
        let promoId = location.state.PromoCodeID;
        let flag = "R";
        await getPromoData(promoId, flag);
        setMode("view");
        viewModeUnable();
      } else {
        console.log("hello");
        setMode("add");
        addModeUnable();
      }
    };
    fetchCompanyData();
  }, []);

  useEffect(() => {
    settingValue();
  }, [PromoData]);

  const settingValue = () => {
    if (PromoId != -1 || PromoData.length > 0) {
      let obj = watch();
      for (let key in obj) {
        setValue(key, PromoData[0][key]);
      }
      // setStatus(PromoData[0]["Status"]);
      viewModeUnable();
    } else {
      setMode("add");
      addModeUnable();
      resetFunc();
    }
  };

  const viewModeUnable = () => {
    setAllTextDisabled(true);
    setAllButtonDisabled(false);
  };

  const addModeUnable = () => {
    setAllTextDisabled(false);
    setAllButtonDisabled(true);
  };

  const getPromoData = async (promoId, flag) => {
    try {
      const response = await axios.post(`MstPromoCode/RetriveMstPromoCode`, {
        PromoCodeID: promoId,
        Flag: flag,
      });
      console.log("res", response);
      if (response.data.Status === 0) {
        console.log("response", response);

        setPromoData(response.data.Data);
        setPromoId(response.data.Data[0].PromoCodeID);
        setDiscType(response.data.Data[0].DiscType);
        setStatus(response.data.Data[0].Status || "0");
        // setValue("Status", response.data.Data[0].Status || "0"); 

      } else {
        console.error("Error fetching PromoCode data:", response.data.Message);
      }
    } catch (error) {
      console.error("Error fetching PromoCode data:", error);
    }
  };

  const handlePrevClick = () => {
    getPromoData(PromoId, "P");
  };

  const handleNextClick = () => {
    getPromoData(PromoId, "N");
  };

  const handlePrint = () => {
    toast.warn("You can't print the promocode coupon!", { autoClose: 1000 });
  };

  const resetFunc = () => {
    reset({
      PromoCodeName: "",
      DiscountAmt: "",
      DiscType: "",
      FreeMonth: "",
      Remark: "",
      Status: 0,
    });
    setStatus(0);
  };

  const handleRadioChange = (event) => {
    setDiscType(event.target.value);
  };

  const handleAddClick = () => {
    const hasPermission = false;
    if (!hasPermission) {
      toast.warn("You can't add coupon record!");
      return;
    }
    addModeUnable();
    setMode("add");
    resetFunc();
    setDiscType("M");
    setStatus("1");
  };

  const handleSubmit = async () => {
    setValue("DiscType", DiscType);
    if (DiscType === "FreeMonth") {
      setValue("FreeMonth", watch("DiscountAmt"));
      setValue("DiscountAmt", 0);
    } else {
      setValue("FreeMonth", 0);
      setValue("DiscountAmt", watch("DiscountAmt"));
    }
    let obj = watch();
    console.log(obj);
    obj.FreeMonth = parseInt(obj.FreeMonth);
    obj.DiscountAmt = parseInt(obj.DiscountAmt);
    obj.Status = watch("Status") ? "1" : "0";

    if (Mode === "add") {
      obj.CreatedBy = parseInt(UserId, 10);
      try {
        const response = await axios.post(
          `MstPromoCode/InsertMstPromoCode`,
          obj
        );
        console.log("res", response);
        if (response.data.Status === 0) {
          console.log("response", response);
          toast.success(response.data.Message, { autoClose: 1000 });
          getPromoData(response.data.Data, "R");
          setDiscType(obj.DiscType);
        } else {
          console.error(
            "Error fetching PromoCode data:",
            response.data.Message
          );
        }
      } catch (error) {
        console.error("Error fetching PromoCode data:", error);
      }
    } else {
      obj.PromoCodeID = PromoId;
      obj.UpdatedBy = parseInt(UserId, 10);
      console.log("update obj", obj);
      await UnLock(PromoId, "MstPromoCode", "PromoCodeID");
      try {
        const response = await axios.post(
          `MstPromoCode/UpdateMstPromoCode`,
          obj
        );
        console.log("res update", response);
        if (response.data.Status === 0) {
          console.log("response", response);
          toast.success(response.data.Message, { autoClose: 1000 });
          getPromoData(PromoId, "R");
          setDiscType(obj.DiscType);
        } else {
          console.error(
            "Error fetching PromoCode data:",
            response.data.Message
          );
        }
      } catch (error) {
        console.error("Error fetching PromoCode data:", error);
      }
    }
  };

  const handleCancel = async () => {
    if (Mode === "add") {
      await getPromoData(1, "L");
    } else {
      await UnLock(PromoId, "MstPromoCode", "PromoCodeID");
      await getPromoData(PromoId, "R");
    }
    settingValue();
    setAllButtonDisabled(false);
    setAllTextDisabled(true);
  };

  const handleEdit = async () => {
    let Flag = await checkAndLock(PromoId, "MstPromoCode", "PromoCodeID");
    switch (Flag) {
      case 0:
        addModeUnable();
        setMode("edit");
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Faled To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("something Went Wrong", { autoClose: 500 });
    }
    // addModeUnable();
    // setMode("view");
  };

  const handleChangeStatus = (e) => {
    let status = e.target.checked ? "1" : "0";
    setStatus(status);
    console.log("statuscheck", status);
    setValue("Status", status);
  };

  const handleBackTotable = () => {
    navigate(`/promotable`);
  };

  const handleDeleteClick = async () => {
    let Flag = await checkAndLock(PromoId, "MstPromoCode", "PromoCodeID");
    switch (Flag) {
      case 0:
        setopenConfirmDialog(true);
        break;
      case 1:
        toast.info("Record Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Faled To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("something Went Wrong", { autoClose: 500 });
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await axios.post(`MstPromoCode/RetriveMstPromoCode`, {
        PromoCodeID: PromoId,
        Flag: "D",
      });
      if (response instanceof Error) {
        return toast.error("Error: could not delete promocode");
      }
      const {
        data: { Status, Message, Data },
      } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 500 });
        await getPromoData(PromoId, "N");
        setopenConfirmDialog(false);
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 500 });
        } else {
          toast.error(Message, { autoClose: 500 });
        }
      }
      await UnLock(PromoId, "MstPromoCode", "PromoCodeID");
      setAllTextDisabled(true);

    } catch (error) {
      console.error("Error fetching PromoCode data:", error);
    }
  };

  const handleCancelDialogButton = () => {
    setopenConfirmDialog(false);
  };
  return (
    <>
      <Box className="form-container">
        <ToastContainer />
        <Grid container spacing={2} className="form_grid">
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Grid>
              <Button
                variant="contained"
                size="small"
                className="three-d-button-previous"
                disabled={AllButtonDisabled}
                onClick={handlePrevClick}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{ margin: "0px 10px" }}
                className="three-d-button-next"
                disabled={AllButtonDisabled}
                onClick={handleNextClick}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography variant="h5" sx={{ margin: "Auto" }}>
              PromoCode Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Promocode Master"
                mode={Mode}
                onAdd={handleAddClick}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleDeleteClick}
                onExit={handleBackTotable}
                readOnlyMode={!AllButtonDisabled}
                onPrevious={handlePrevClick}
                onNext={handleNextClick}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={1}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  id="PromoCodeName"
                  name="PromoCodeName"
                  label={
                    <span>
                      PromoCode Name<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  {...register("PromoCodeName")}
                  value={watch("PromoCodeName") || ""}
                  disabled={AllTextDisabled}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label={
                    <span>
                      Remark
                      {/* <span style={{ color: 'red' }}>*</span> */}
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  {...register("Remark")}
                  value={watch("Remark") || ""}
                  disabled={AllTextDisabled}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} className="form_field">
            <div style={{ marginLeft: "10px", color: "#616161" }}>
              DiscountType<span style={{ color: "red" }}>*</span>
            </div>
            <Grid container spacing={1}>
              {/* <Grid item>
                <FormLabel component="legend">DiscountType</FormLabel>
              </Grid> */}

              <Grid item xs={12} md={4} lg={4.5}>
                <FormControl component="fieldset">
                  <RadioGroup
                    aria-label="DiscType"
                    name="DiscType"
                    value={DiscType}
                    {...register("DiscType")}
                    onChange={handleRadioChange}
                    row
                  >
                    <FormControlLabel
                      value="F"
                      control={
                        <Radio
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                        />
                      }
                      label="Free Month"
                      className="custom-textfield"
                      disabled={AllTextDisabled}
                    />
                    <FormControlLabel
                      value="M"
                      control={
                        <Radio
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                        />
                      }
                      label="Monthly"
                      className="custom-textfield"
                      disabled={AllTextDisabled}
                    />
                    <FormControlLabel
                      value="L"
                      control={
                        <Radio
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
                        />
                      }
                      label="LumpSum"
                      className="custom-textfield"
                      disabled={AllTextDisabled}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} lg={3.5}>
                <TextField
                  id="DiscountAmt"
                  name="DiscountAmt"
                  label={
                    <span>
                      {DiscType === "F"
                        ? "Free Month"
                        : DiscType === "M"
                          ? "Monthly Discount"
                          : "LumpSum Discount"}{" "}
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  {...register("DiscountAmt")}
                  value={watch("DiscountAmt") || ""}
                  disabled={AllTextDisabled}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={AllTextDisabled}
                        {...register("Status")}
                        checked={Status === "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_field">
            <Grid container spacing={2}>
              {/* <Grid item xs={12} md={4} lg={4}>
                <TextField
                  id="FreeMonth"
                  name="FreeMonth"
                  label={
                    <span>
                      Free Month
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  {...register('FreeMonth')}
                  value={watch('FreeMonth') || ""}
                  disabled={AllTextDisabled}
                />
              </Grid> */}
              {/* <Grid item xs={12} md={4} lg={4}>
              <TextField
                  id="DiscountAmt"
                  name="DiscountAmt"
                  label={
                    <span>
                      Discount Amount<span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  {...register('DiscountAmt')}
                  value={watch('DiscountAmt') || ""}
                  disabled={AllTextDisabled}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <FormGroup>
                  <FormControlLabel control={<Checkbox disabled={AllTextDisabled} {...register('Status')} checked={Status} onChange={handleChangeStatus} />} label="Status" />

                </FormGroup>
              </Grid> */}
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button">
            <>
              <Button
                variant="contained"
                sx={{
                  mr: 1,
                  background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                }}
                onClick={handleSubmit}
                disabled={AllTextDisabled}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                sx={{
                  mr: 1,
                  background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                }}
                disabled={AllTextDisabled}
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </>
          </Grid>
        </Grid>
      </Box>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCancelDialogButton}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCancelDialogButton}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PromoCodeMaster;
